<header class="px-3 py-3 bg-primary">
  <h3 class="m-0 flex gap-2 align-items-center">
    {{ indicatorStore.getFullName(indicator) }}
  </h3>
</header>
@if (hasMeaningfulContent(indicator.calculation || parent?.calculation)) {
  <div class="px-3 py-2 surface-ground">
    <h4 class="mt-2 mb-3 flex align-items-center gap-2">
      <i class="fas fa-calculator"></i> <strong>Berechnung</strong>
    </h4>
    <div [innerHTML]="indicator.calculation || parent?.calculation"></div>
  </div>
}
@if (hasMeaningfulContent(indicator.statement || parent?.statement)) {
  <div class="px-3 py-2">
    <h4 class="mt-2 mb-3 flex align-items-center gap-2">
      <i class="fas fa-bullhorn"></i> <strong>Aussage</strong>
    </h4>
    <div [innerHTML]="indicator.statement || parent?.statement"></div>
  </div>
}
@if (hasMeaningfulContent(indicator.indication || parent?.indication)) {
  <div class="px-3 py-2">
    <h4 class="mt-2 mb-3 flex align-items-center gap-2">
      <i class="fas fa-comment-medical"></i> <strong>Hinweis auf</strong>
    </h4>
    <div [innerHTML]="indicator.indication || parent?.indication"></div>
  </div>
}
@if (hasMeaningfulContent(indicator.source || parent?.source)) {
  <div class="px-3 py-2">
    <h4 class="mt-2 mb-3 flex align-items-center gap-2">
      <i class="fas fa-copyright"></i> <strong>Quelle</strong>
    </h4>
    <div
      class="font-italic"
      [innerHTML]="indicator.source || parent?.source"></div>
  </div>
}

@if (
  !(
    indicator.calculation ||
    parent?.calculation ||
    indicator.statement ||
    parent?.statement ||
    indicator.indication ||
    parent?.indication ||
    indicator.source ||
    parent?.source
  )
) {
  <div class="px-3 py-2">
    <p class="text-color-secondary font-italic">
      Keine weiteren Informationen verfügbar.
    </p>
  </div>
}
